import { FOOTER_MODES, deriveFooterMode } from 'src/consumer/constants'
import { PMPV2FooterContainer } from '../../PrescriptionMakingPageStyles'
import { PrescriptionFooter } from '../../PrescriptionMakingPageComponents'

export default function PrescriptionPrintableFooter({
  debugMode,
  prescriptionData,
  prescriptionParentDivDimensions,
  printType,
  footerHeight,
  leaveSpace,
  styleOverrides,
  useFullUrlForFooterImages,
  currentPage,
  totalPages,
}) {
  // The auto-created footer auto-sizes to its content instead of reserving a fixed
  // footerHeight band — so the footer strip hugs its content and sits flush at the page
  // bottom (no large empty footer area).
  const isConfigFooter = deriveFooterMode(prescriptionData?.footer) === FOOTER_MODES.auto

  return (
    <PMPV2FooterContainer
      debug={debugMode}
      data-print-footer="true"
      style={{
        height: isConfigFooter ? 'auto' : `${footerHeight}px`,
        minHeight: isConfigFooter ? 0 : undefined,
        borderTop: leaveSpace ? '1px solid #000' : 'unset',
        flexShrink: 0,
        marginTop: 'auto', // Push footer to bottom of flex container
      }}
      prescriptionWidth={prescriptionParentDivDimensions?.width}
    >
      <PrescriptionFooter
        prescriptionData={prescriptionData}
        leaveSpace={leaveSpace}
        debug={debugMode}
        prescriptionWidth={prescriptionParentDivDimensions?.width}
        styleOverrides={styleOverrides}
        useCompleteImageLink={useFullUrlForFooterImages}
        footerHeight={footerHeight}
        currentPage={currentPage}
        totalPages={totalPages}
      />
    </PMPV2FooterContainer>
  )
}
